import { Link, ListItem, Typography } from '@mui/material';

import {
  AnnouncementIcon,
  CancelIcon,
  CheckIcon,
  InfoIcon,
} from '@components/icons';

import { FORMAT_DATE_WITH_TIME, formatDate } from '@utils/date';
import { isEmoji } from '@utils/string/isEmoji';

type MessageItemProps = {
  link?: string;
  date: string;
  type: string;
  viewed: boolean;
  message: string | null | undefined;
};

const getIconByType = (type: string) => {
  switch (type) {
    case 'success':
      return (
        <CheckIcon sx={{ color: '#3E9218', fontSize: '0.875rem', mr: 1 }} />
      );
    case 'error':
      return (
        <CancelIcon sx={{ color: '#E21A1A', fontSize: '0.875rem', mr: 1 }} />
      );
    case 'info':
      return <InfoIcon sx={{ color: '#556776', fontSize: '1rem', mr: 1 }} />;
    case 'announcement':
      return (
        <AnnouncementIcon
          sx={{ color: '#3385B4', fontSize: '0.875rem', mr: 1 }}
        />
      );
    default:
      return null;
  }
};

export const MessageItem = (props: MessageItemProps) => {
  const { type, message, link, viewed, date } = props;

  const icon = isEmoji(message?.substring(0, 2) ?? '')
    ? null
    : getIconByType(type);
  return (
    <ListItem
      disablePadding
      sx={{
        px: 1,
        py: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        borderBottom: '1px solid #F5F5F5',
      }}
    >
      <Typography
        sx={{
          fontWeight: viewed ? 'normal' : 'bold',
        }}
        variant="body2"
      >
        {icon}
        {message}
      </Typography>
      {link && (
        <Link
          rel="noreferrer"
          target="_blank"
          variant="body2"
          sx={{ my: 1, color: '#5298C1' }}
          href={link}
        >
          Скачать
        </Link>
      )}
      <Typography
        sx={{
          color: '#B0B7BC',
        }}
        variant="body2"
      >
        {formatDate(date, FORMAT_DATE_WITH_TIME)}
      </Typography>
    </ListItem>
  );
};
